import PropTypes from 'prop-types';

import StoryNormal from './StoryNormal';
import StoryFeaturedAsset from './StoryFeaturedAsset';
import StoryRecipeSteps from './StoryRecipeSteps';
import StoryTwoColumns from './StoryTwoColumns';

import { CtfStoryStyle } from '@/utils/constants';
import { isDDEnv } from '@/utils/helper';
import StoryNormalDD from './StoryNormalDD';

function Story({ assets, compactSpace, entries, fields }) {
  // @TODO: Improve variable spreading and type checking.
  const { style } = fields;

  const isDD = isDDEnv();

  if (style === CtfStoryStyle.ASSET) {
    return (
      <StoryFeaturedAsset
        compactSpace={compactSpace}
        fields={fields}
        assets={assets}
        entries={entries}
      />
    );
  } else if (style === CtfStoryStyle.RECIPE_STEPS) {
    return (
      <StoryRecipeSteps fields={fields} assets={assets} entries={entries} />
    )
  } else if (style === CtfStoryStyle.TWO_COLUMNS) {
    return (
      <StoryTwoColumns fields={fields} assets={assets} entries={entries} />
    )
  }

  if(isDD) {
    return <StoryNormalDD compactSpace={compactSpace} fields={fields} assets={assets} entries={entries} />
  }

  return <StoryNormal compactSpace={compactSpace} fields={fields} assets={assets} entries={entries} />
}

Story.propTypes = {
  assets: PropTypes.array,
  entries: PropTypes.array,
  compactSpace: PropTypes.bool,
  fields: PropTypes.object,
};

export default Story;
